import { formatDate } from '@/utils/date'

const UncategorizedData = ({ uncategorized }) => {
    return (<>
        <h4 className="mt-4">Uncategorized Data</h4>
        <div className="-mt-1 pb-2 text-sm text-slate-400">
            Lists all documents that didn't apply to any Suggested Tab above
        </div>
        
        <div className="bg-base-100 max-h-[20vh] overflow-auto rounded mb-4">
            
            <table className="table table-sm table-bordered table-zebra table-pin-rows">
                <thead>
                    <tr>
                        <th>Document</th>
                        <th>Instrument Type</th>
                        <th>Instrument Date</th>
                        <th>Grantor</th>
                        <th>Grantee</th>
                    </tr>
                </thead>
                <tbody>
                    {uncategorized.map(d => <tr key={d.id}>
                        <td>{d.document.name}</td>
                        <td>{d.value.instrumentType}</td>
                        <td>{d.value.instrumentDate ? formatDate(d.value.instrumentDate) : ''}</td>
                        <td>{d.value.grantors.map(g => g.name).join('; ')}</td>
                        <td>{d.value.grantees.map(g => g.name).join('; ')}</td>
                    </tr>)}
                </tbody>
            </table>
        </div>
    </>
    )
}

export default UncategorizedData